import { clsx } from "clsx";

import styles from "@/components/ui/spinner/spinner.module.css";

type Size = "xs" | "sm" | "md";

const variantToClassMap: Record<Size, string> = {
    xs: styles.spinner_xs,
    sm: styles.spinner_sm,
    md: styles.spinner_md,
};

interface Props {
    size?: Size;
}

// TODO: props should not be optional
export const Spinner = (props?: Props) => {
    const { size = "md" } = props ?? {};
    return <div className={clsx(styles.spinner, variantToClassMap[size])}></div>;
};
